// Centralized site content for Maa Durga Palace & Guest House.
// PRIMARY business: Kalyana Mandap / Wedding Palace.
// SECONDARY business: Guest House / Hotel accommodation.

export const HOTEL = {
  name: "Maa Durga Palace & Guest House",
  shortName: "Maa Durga Palace",
  tagline: "Wedding Palace · Kalyana Mandap · Guest House",
  logo:
    "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/820qosoa_WhatsApp%20Image%202026-05-27%20at%207.12.29%20PM.jpeg",
  rating: 4.1,
  reviewCount: "385+",
  phone: "9437102852",
  phoneFormatted: "+91 94371 02852",
  phoneE164: "+919437102852",
  whatsapp: "9437102852",
  whatsappLink:
    "https://wa.me/919437102852?text=" +
    encodeURIComponent(
      "Namaste! I'd like to enquire about the wedding palace / venue at Maa Durga Palace, Bhadrak.",
    ),
  whatsappStay:
    "https://wa.me/919437102852?text=" +
    encodeURIComponent(
      "Namaste! I'd like to enquire about a room at Maa Durga Palace & Guest House.",
    ),
  address: {
    line1: "3F7F+9F, Bagurai",
    city: "Bhadrak",
    state: "Odisha",
    pin: "756181",
    country: "India",
  },
  fullAddress: "3F7F+9F, Bagurai, Bhadrak, Odisha 756181, India",
  mapsLink: "https://maps.app.goo.gl/GK2QzxJD5BPZjVYZ9",
  mapsEmbed:
    "https://www.google.com/maps?q=Maa+Durga+Palace+%26+Guest+House+Bagurai+Bhadrak+Odisha+756181&output=embed",
  checkIn: "12:00 PM",
  checkOut: "11:00 AM",
};

/* ============================================================
   PRIMARY: WEDDING PALACE / KALYANA MANDAP
   ============================================================ */

export const HERO_STATS = [
  { k: "500+", v: "Weddings Hosted" },
  { k: "2500+", v: "Sq. Ft. Hall" },
  { k: "Family", v: "Accommodation" },
  { k: "385+", v: "Trusted Reviews" },
];

export const WEDDING_PALACE = {
  title: "A Royal Kalyana Mandap, made for once-in-a-lifetime moments.",
  intro:
    "From sacred mandap ceremonies and grand receptions to engagements, birthdays and family gatherings — Maa Durga Palace transforms every occasion into a memory worth telling for generations.",
  bullets: [
    {
      title: "Wedding Hall",
      desc: "A grand main hall with traditional ornamentation, accent lighting and a regal stage for the bride and groom.",
    },
    {
      title: "Reception Space",
      desc: "Spacious seating, premium dining layout and an elegant ambience for receptions of every scale.",
    },
    {
      title: "Engagement Ceremonies",
      desc: "Intimate, beautifully styled settings for ring exchanges, betrothals and pre-wedding rituals.",
    },
    {
      title: "Birthday & Family Events",
      desc: "From milestone birthdays to family pujas and corporate gatherings — our halls adapt to every celebration.",
    },
    {
      title: "Odia Wedding Ambience",
      desc: "Traditional Odisha décor cues — temple arches, marigold ornaments, brass lanterns and ceremonial mandap.",
    },
  ],
  capacity: [
    { label: "Main Mandap Hall", value: "Up to 500 guests" },
    { label: "Reception Setup", value: "Up to 400 seated" },
    { label: "Engagement / Pooja", value: "Up to 150 guests" },
    { label: "Parking", value: "60+ vehicles" },
  ],
  images: [
    "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/9a02a6lk_542000ee-9092-448a-81e2-cbca59bb7bd1.png",
    "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/0sqh5etb_0736239a-4c4e-44b5-bc0d-6fb6ecb32d0e.png",
    "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/yi41limy_WhatsApp%20Image%202026-05-27%20at%207.10.44%20PM%20%281%29.jpeg",
    "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/y9v258tp_WhatsApp%20Image%202026-05-27%20at%207.10.44%20PM.jpeg",
    "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/ho6mw9j4_WhatsApp%20Image%202026-05-27%20at%207.10.45%20PM.jpeg",
  ],
};

export const WEDDING_FEATURES = [
  {
    icon: "Crown",
    title: "Spacious Marriage Hall",
    desc: "A grand pillared hall sized for 500+ guests with premium acoustics.",
  },
  {
    icon: "Sparkles",
    title: "Bridal Room",
    desc: "Private, well-lit dressing suite for the bride and her family.",
  },
  {
    icon: "BedDouble",
    title: "Guest Accommodation",
    desc: "On-site rooms so out-of-town guests stay where the celebration happens.",
  },
  {
    icon: "Utensils",
    title: "Catering Space",
    desc: "Dedicated kitchen & buffet area built for large-scale Indian feasts.",
  },
  {
    icon: "Car",
    title: "Ample Parking",
    desc: "On-site secure parking for 60+ vehicles — convenient for every guest.",
  },
  {
    icon: "Flower2",
    title: "Traditional Décor",
    desc: "Mandap, marigold, brass lamps & Odia ornamentation included on request.",
  },
  {
    icon: "Lightbulb",
    title: "Event Lighting",
    desc: "Cinematic gold and warm-white lighting setups — pre-installed.",
  },
  {
    icon: "Heart",
    title: "Family-Friendly Hosts",
    desc: "A dedicated coordinator for every event — calm, attentive, on-call.",
  },
];

export const WEDDING_GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/4wnud2zf_04e03b94-34c7-4ac8-b052-78f3a789ade1.png",
    alt: "Maa Durga Kalyan Mandap floral entrance at night, Bhadrak",
    span: "row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/1vpfg6e7_0ddf1701-d82b-48af-b70f-a273d1695fcf.png",
    alt: "Spacious AC banquet hall with red & gold chairs",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/pwa5o3hi_082a21f8-0c7c-4c5b-9114-3b4500aaa941.png",
    alt: "Triple red floral archway entrance to the Kalyan Mandap",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/fku85b4e_542000ee-9092-448a-81e2-cbca59bb7bd1.png",
    alt: "Royal red & gold wedding throne with floral mandap backdrop",
    span: "row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/z650xmh1_0736239a-4c4e-44b5-bc0d-6fb6ecb32d0e.png",
    alt: "Traditional warrior guards welcoming guests at the lit-up entry tunnel",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/4wnud2zf_04e03b94-34c7-4ac8-b052-78f3a789ade1.png",
    alt: "Maa Durga Kalyan Mandap entrance, full floral facade",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/pwa5o3hi_082a21f8-0c7c-4c5b-9114-3b4500aaa941.png",
    alt: "Red & white floral arches with lanterns and red carpet aisle",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/1vpfg6e7_0ddf1701-d82b-48af-b70f-a273d1695fcf.png",
    alt: "Banquet seating ready for the reception",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/wbjyr3wr_0d90668d-f24c-4613-8d9d-11e0574570fe.png",
    alt: "Royal blue & white banquet setup with gold chafing dishes",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/k2a200u6_8b7fedbe-fbc7-43b9-8da2-dfbb51e42e74.png",
    alt: "Golden floral mandap with white throne, chandelier and neon heart accents",
    span: "row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/c77tmecj_287e0f79-5d4e-4cf8-bae6-da8ddec26de6.png",
    alt: "Vibrant yellow & pink draped buffet stations inside the hall",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/t4e2yh25_04e03b94-34c7-4ac8-b052-78f3a789ade1.png",
    alt: "Maa Durga Kalyan Mandap signature illuminated entrance at night",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/6mjhko7x_19450482-5f27-4ba3-82cb-813bd8497a4b.png",
    alt: "Guests walking through the chandelier-lit floral baraat tunnel",
    span: "row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/y8wny5pq_69aee9c2-e245-408d-91e0-c9b3b7043ebf.png",
    alt: "Spacious buffet hall with blue marble pillars and gold chafing dishes",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/emplxxc7_d885a9d5-a887-4728-98ba-668b5badfbea.png",
    alt: "Maa Durga Kalyan Mandap night entrance with neon lions and butterfly lights",
    span: "row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/cr1l9qan_dbfe738b-e810-4789-8c90-6d070d947df9.png",
    alt: "Banarasi Paan counter with neon décor for the wedding reception",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/lxf02war_f1a52206-455a-4304-b4ff-1979ae830ff4.png",
    alt: "Intimate floral mandap with chandelier and ivory throne",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/rlqcbhhb_69aee9c2-e245-408d-91e0-c9b3b7043ebf.png",
    alt: "Buffet hall ready for the wedding feast",
    span: "",
  },
  /* Cinematic videos */
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/j13i5kup_WhatsApp%20Video%202026-05-28%20at%2012.46.27%20AM.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/4wnud2zf_04e03b94-34c7-4ac8-b052-78f3a789ade1.png",
    alt: "Cinematic walkthrough of the Maa Durga Palace mandap",
    span: "row-span-2",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/v8rhr1l3_WhatsApp%20Video%202026-05-28%20at%2012.47.47%20AM.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/fku85b4e_542000ee-9092-448a-81e2-cbca59bb7bd1.png",
    alt: "Wedding hall lights & décor in motion",
    span: "",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/x2m8m57x_WhatsApp%20Video%202026-05-28%20at%2012.49.34%20AM.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/k2a200u6_8b7fedbe-fbc7-43b9-8da2-dfbb51e42e74.png",
    alt: "Reception stage & floral setup",
    span: "",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/mz8h2olk_WhatsApp%20Video%202026-05-28%20at%2012.51.05%20AM.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/6mjhko7x_19450482-5f27-4ba3-82cb-813bd8497a4b.png",
    alt: "Glowing baraat entry tunnel",
    span: "row-span-2",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/omeopzuz_WhatsApp%20Video%202026-05-28%20at%2012.54.15%20AM.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/emplxxc7_d885a9d5-a887-4728-98ba-668b5badfbea.png",
    alt: "Inside the celebrated Kalyan Mandap on the wedding night",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/q87f2l2z_WhatsApp%20Image%202026-05-28%20at%201.51.13%20AM%20%281%29.jpeg",
    alt: "Pastel floral archway with grass-wall backdrop and pedestal blooms",
    span: "row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/9xofwvy8_WhatsApp%20Image%202026-05-28%20at%201.51.13%20AM.jpeg",
    alt: "Golden ceremony stage with ivory throne and floral arches",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/ayh6t44y_WhatsApp%20Image%202026-05-28%20at%201.51.14%20AM.jpeg",
    alt: "Family gathered before the floral red mandap for the ceremony",
    span: "",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/w42ozkbk_WhatsApp%20Video%202026-05-28%20at%201.45.41%20AM.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/9xofwvy8_WhatsApp%20Image%202026-05-28%20at%201.51.13%20AM.jpeg",
    alt: "Cinematic moment from the wedding celebration",
    span: "row-span-2",
  },
  /* New uploads — July 2026 wedding portfolio additions */
  {
    src: "https://customer-assets.emergentagent.com/job_0759a643-fd2b-41c1-a44e-23213b953038/artifacts/olf7hju2_WhatsApp%20Image%202026-07-02%20at%204.12.46%20PM.jpeg",
    alt: "Neon-lit draped ceiling tunnel with chevron floor and floral stands at Maa Durga Palace",
    span: "row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_0759a643-fd2b-41c1-a44e-23213b953038/artifacts/kp61vgej_WhatsApp%20Image%202026-07-02%20at%204.12.51%20PM.jpeg",
    alt: "Regal ivory & gold wedding throne with pastel floral arch backdrop",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_0759a643-fd2b-41c1-a44e-23213b953038/artifacts/o4mbjvss_WhatsApp%20Image%202026-07-02%20at%204.12.54%20PM.jpeg",
    alt: "Maa Durga Palace signature outdoor entrance with lit floral archway and red carpet",
    span: "row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_0759a643-fd2b-41c1-a44e-23213b953038/artifacts/mfblielr_WhatsApp%20Image%202026-07-02%20at%204.12.55%20PM%20%281%29.jpeg",
    alt: "Green grass wall floral archway with pastel roses and rustic wooden pedestals",
    span: "",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_0759a643-fd2b-41c1-a44e-23213b953038/artifacts/dvvuv2s2_WhatsApp%20Image%202026-07-02%20at%204.12.55%20PM.jpeg",
    alt: "Ivory & gold reception stage with hanging vines, floral canopy and cream throne",
    span: "row-span-2",
  },
  /* New uploads — July 2026 cinematic wedding videos */
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_0759a643-fd2b-41c1-a44e-23213b953038/artifacts/2uem7wg1_WhatsApp%20Video%202026-07-02%20at%204.12.54%20PM.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_0759a643-fd2b-41c1-a44e-23213b953038/artifacts/o4mbjvss_WhatsApp%20Image%202026-07-02%20at%204.12.54%20PM.jpeg",
    alt: "Cinematic entrance walkthrough of the illuminated Kalyan Mandap",
    span: "row-span-2",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_0759a643-fd2b-41c1-a44e-23213b953038/artifacts/vrjgezuk_WhatsApp%20Video%202026-07-02%20at%204.12.55%20PM.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_0759a643-fd2b-41c1-a44e-23213b953038/artifacts/kp61vgej_WhatsApp%20Image%202026-07-02%20at%204.12.51%20PM.jpeg",
    alt: "Floral wedding stage cinematic pan — throne and pastel blooms in motion",
    span: "",
  },
  {
    type: "video",
    src: "https://customer-assets.emergentagent.com/job_0759a643-fd2b-41c1-a44e-23213b953038/artifacts/q5b23wj3_WhatsApp%20Video%202026-07-02%20at%204.12.57%20PM.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_0759a643-fd2b-41c1-a44e-23213b953038/artifacts/dvvuv2s2_WhatsApp%20Image%202026-07-02%20at%204.12.55%20PM.jpeg",
    alt: "Reception stage in motion — golden lights, hanging vines and floral canopy",
    span: "row-span-2",
  },
];

/* ============================================================
   SECONDARY: GUEST HOUSE / ACCOMMODATION
   ============================================================ */

export const ABOUT_IMAGE =
  "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/mbxsszjj_WhatsApp%20Image%202026-05-28%20at%202.06.53%20AM.jpeg";

export const ROOMS = [
  {
    id: "ac",
    name: "AC Room",
    description:
      "Cool, quiet and freshly serviced. Perfect for wedding guests staying one or two nights.",
    features: ["Air Conditioning", "King / Queen Bed", "Hot Water", "Free WiFi", "Daily Housekeeping"],
    images: [
      "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=1400&q=80",
      "https://images.unsplash.com/photo-1618773928121-c32242e63f39?auto=format&fit=crop&w=1400&q=80",
      "https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&w=1400&q=80",
    ],
    badge: "Most Popular",
  },
  {
    id: "deluxe",
    name: "Deluxe Room",
    description:
      "An elevated stay for the bridal party or close family — refined interiors and a generous workspace.",
    features: ["Premium AC", "Spacious King Bed", "Workspace", "Smart TV", "Tea/Coffee Maker"],
    images: [
      "https://images.unsplash.com/photo-1618773928121-c32242e63f39?auto=format&fit=crop&w=1400&q=80",
      "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=1400&q=80",
      "https://images.unsplash.com/photo-1631049552057-403cdb8f0658?auto=format&fit=crop&w=1400&q=80",
    ],
    badge: "Premium",
  },
  {
    id: "family",
    name: "Family Room",
    description:
      "Two large beds, extra seating and storage — ideal for relatives travelling in for the celebration.",
    features: ["Sleeps 4", "Twin + Queen Bed", "Family Bathroom", "Mini Fridge", "Extra Storage"],
    images: [
      "https://images.pexels.com/photos/35868592/pexels-photo-35868592.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
      "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=1400&q=80",
      "https://images.unsplash.com/photo-1590490360182-c33d57733427?auto=format&fit=crop&w=1400&q=80",
    ],
    badge: "Family Favourite",
  },
];

export const AMENITIES = [
  { icon: "Car", title: "Free Parking", desc: "On-site secure parking for guests & baraat." },
  { icon: "Wifi", title: "Free WiFi", desc: "High-speed internet across the property." },
  { icon: "BellRing", title: "Event Coordination", desc: "Dedicated host for every function." },
  { icon: "Sparkles", title: "Spotlessly Clean", desc: "Daily housekeeping & fresh linen." },
  { icon: "ShieldCheck", title: "24/7 Assistance", desc: "Front desk help, anytime you need." },
  { icon: "Users", title: "Family Stay", desc: "Spacious family rooms & extra beds." },
  { icon: "MapPin", title: "Easy Transport", desc: "Close to bus stand & main roads." },
  { icon: "Coffee", title: "Tea & Coffee", desc: "Complimentary in-room hot drinks." },
];

/* ============================================================
   REVIEWS — mixed wedding-venue + stay testimonials
   ============================================================ */

export const REVIEWS = [
  {
    name: "Subhasish Mohanty",
    initials: "SM",
    rating: 5,
    date: "2 weeks ago",
    body: "Hosted my sister's wedding here. The mandap looked grand, lighting was spot-on, and the staff coordinated everything beautifully. Easily the best venue we considered in Bhadrak.",
    tag: "Wedding",
  },
  {
    name: "Priyanka Das",
    initials: "PD",
    rating: 5,
    date: "1 month ago",
    body: "Booked the hall for our engagement and the family rooms for out-of-town guests. Everything under one roof — saved us so much running around. The owner was respectful and helpful.",
    tag: "Engagement + Stay",
  },
  {
    name: "Rakesh Behera",
    initials: "RB",
    rating: 4,
    date: "1 month ago",
    body: "Decent reception venue with very good parking — important when 300+ guests show up. Catering arrangement worked smoothly. Will recommend for medium-large weddings.",
    tag: "Reception",
  },
  {
    name: "Meera Patnaik",
    initials: "MP",
    rating: 4,
    date: "3 months ago",
    body: "Friendly staff and quick check-in. Room service was prompt, beds were comfortable. Good place to stay even outside of any event.",
    tag: "Stay",
  },
  {
    name: "Arjun Sahoo",
    initials: "AS",
    rating: 4,
    date: "2 months ago",
    body: "Hosted my son's first birthday party in the smaller hall. Looked so festive once decorated. Great value, and the family rooms upstairs were a bonus for relatives.",
    tag: "Family Event",
  },
  {
    name: "Debasish Jena",
    initials: "DJ",
    rating: 5,
    date: "4 months ago",
    body: "Excellent venue. The hospitality felt genuine and the wedding hall has a real royal feel after decoration. Highly recommended for traditional Odia weddings.",
    tag: "Wedding",
  },
];

/* ============================================================
   STAY GALLERY (kept for the secondary Photo Gallery section)
   ============================================================ */

export const GALLERY = [
  {
    src: "https://images.unsplash.com/photo-1724947053227-2335bf21d0ae?auto=format&fit=crop&w=1200&q=80",
    alt: "Maa Durga Palace welcoming entrance lobby",
    span: "row-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1596701062351-8c2c14d1fdd0?auto=format&fit=crop&w=900&q=80",
    alt: "Warm Indian hospitality dining experience",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1540304453527-62f979142a17?auto=format&fit=crop&w=900&q=80",
    alt: "Freshly prepared traditional thali",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&w=900&q=80",
    alt: "Sunlit deluxe room with king bed",
    span: "row-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=900&q=80",
    alt: "Air conditioned guest room",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=900&q=80",
    alt: "Quiet seating corner in hotel",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?auto=format&fit=crop&w=900&q=80",
    alt: "Cozy family room interior",
    span: "",
  },
  {
    src: "https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=900&q=80",
    alt: "Modern bathroom amenities",
    span: "",
  },
];

export const NAV_LINKS = [
  { href: "#home", label: "Home" },
  { href: "#mandap", label: "Mandap" },
  { href: "#wedding-features", label: "Venue Features" },
  { href: "#wedding-gallery", label: "Wedding Gallery" },
  { href: "#owner", label: "Owner" },
  { href: "#stay", label: "Stay" },
  { href: "#reviews", label: "Reviews" },
  { href: "#contact", label: "Book" },
];

export const OWNER = {
  name: "Anil Day",
  initials: "AD",
  title: "Retired Merchant Navy Officer & Hospitality Visionary",
  // Real photographs of Mr. Anil Day, founder
  portraits: [
    "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/hnbup8v4_WhatsApp%20Image%202026-05-25%20at%204.38.55%20PM.jpeg",
    "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/em0fdfha_WhatsApp%20Image%202026-05-25%20at%204.38.56%20PM.jpeg",
  ],
  portrait:
    "https://customer-assets.emergentagent.com/job_maa-durga-palace/artifacts/hnbup8v4_WhatsApp%20Image%202026-05-25%20at%204.38.55%20PM.jpeg",
  paragraphs: [
    "Led by Mr. Anil Day, a retired Merchant Navy Officer, Maa Durga Palace & Guest House reflects discipline, hospitality, trust and heartfelt service.",
    "With years of experience serving people across different cultures and places during his maritime career, Mr. Day brings professionalism, cleanliness, comfort and warm Indian hospitality to every guest experience.",
    "His vision is to create a welcoming wedding and stay destination in Bhadrak where families can celebrate special moments with comfort, elegance and peace of mind.",
  ],
  badges: [
    { icon: "Anchor", label: "Years of Discipline" },
    { icon: "HandHeart", label: "Trusted Hospitality" },
    { icon: "Users", label: "Family-Friendly Service" },
    { icon: "BriefcaseBusiness", label: "Professional Management" },
  ],
  quote:
    "Hospitality is not just service — it is making guests feel at home.",
};
